import Invitation from 'app/scripts/models/invitation';

class BoardInvitation extends Invitation {
  public typeName: string;

  static initClass() {
    this.prototype.typeName = 'BoardInvitation';
  }
}
BoardInvitation.initClass();

export { BoardInvitation };
